import { Box, Container } from '@mui/material'
import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'


function TeamContainer() {
  const [value, setValue] = React.useState('0');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Header headline="Mannschaften"></Header>
      <Container maxWidth="xl" sx={{ px: 1, mt: 3 }}>
        <Box sx={{ width: '100%', height: '100vh' }}>
          <iframe
            src="https://services.tennis.de/extern/tennisdeteamsearch.zul?verband=TNB&verein=101052&linkfarbe=20aebd"
            scrolling="yes"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          ></iframe>
        </Box>
      </Container >
      <Footer />
    </>
  )
}

export default TeamContainer